import React from "react";

import { Col as AntCol, ColProps as AntColProps } from "antd";

const getSM = (useDefaultSm: boolean, sm?: number) => {
  if (useDefaultSm) return sm;
  return sm || 24;
};

type ColumnProps = AntColProps & {
  useDefaultSm?: boolean;
  sm?: number;
};

export const Col = ({ children, sm, useDefaultSm = false, ...props }: ColumnProps) => (
  <AntCol sm={getSM(useDefaultSm, sm)} {...props}>
    {children}
  </AntCol>
);

export default Col;
